"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import classNames from "classnames";
import React from "react";
import { observer } from "mobx-react";
import { computed, observable } from "mobx";
import Slider, { SliderTheme } from "./Slider/Slider";
import { randomString } from "../../../utils";
let SliderInput = class extends React.Component {
  constructor(props) {
    super(props);
    this.baseId = `slider-${randomString()}`;
    this.labelId = `${this.baseId}-label`;
    this.onSliderChange = (newValue) => {
      this.rangeInputValue = newValue;
      this.textInputValue = newValue.toString();
      this.props.handleValueChange(newValue);
    };
    this.onTextInputChange = (event) => {
      const inputValue = Number(event.target.value);
      if (isNaN(inputValue)) {
        return;
      }
      const { minimum } = this.props;
      const validInputValue = this.getValidInputValue(inputValue, minimum);
      if (event.target.value.endsWith(".")) {
        this.textInputValue = event.target.value;
        this.rangeInputValue = validInputValue;
      } else {
        this.textInputValue = inputValue.toString();
        this.rangeInputValue = validInputValue;
      }
      this.props.handleValueChange(validInputValue);
    };
    this.onTextInputBlur = () => {
      if (this.props.minimum != void 0 && this.isBelowMin(Number(this.textInputValue))) {
        this.textInputValue = this.props.minimum.toString();
      }
    };
    this.onKeyPressed = (event) => {
      if (event.key === "Enter") {
        event.target.blur();
      }
    };
    this.getValidInputValue = (inputValue, minimum) => {
      if (minimum != void 0 && this.isBelowMin(inputValue)) {
        return minimum;
      } else if (this.isAboveMax(inputValue)) {
        return this.maximum;
      } else {
        return inputValue;
      }
    };
    this.rangeInputValue = this.props.initialInputValue;
    this.textInputValue = this.props.initialInputValue.toString();
  }
  render() {
    const { label, theme, unit, minimum, sliderEventHandlers } = this.props;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames({
          "slider-input": true,
          "slider-input--dark": theme === SliderTheme.Dark
        })
      },
      /* @__PURE__ */ React.createElement("div", { className: "slider-input__input-container" }, /* @__PURE__ */ React.createElement("label", { className: "slider-input__label", htmlFor: `${this.baseId}-text-input`, id: this.labelId }, label, /* @__PURE__ */ React.createElement("span", { className: "slider-input__unit" }, unit)), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "slider-input__text-input",
          type: "text",
          onChange: this.onTextInputChange,
          onBlur: this.onTextInputBlur,
          onKeyPress: this.onKeyPressed,
          value: this.textInputValue,
          id: `${this.baseId}-text-input`,
          "aria-labelledby": this.labelId
        }
      ))),
      /* @__PURE__ */ React.createElement("div", { className: "slider-input__input-container" }, /* @__PURE__ */ React.createElement(
        Slider,
        __spreadValues({
          value: this.rangeInputValue,
          minimum,
          maximum: this.maximum,
          theme,
          onChange: this.onSliderChange,
          label: unit ? `${label} ${unit}` : label
        }, sliderEventHandlers)
      ))
    );
  }
  isBelowMin(inputValue) {
    return this.props.minimum != void 0 && this.props.minimum > inputValue;
  }
  isAboveMax(inputValue) {
    return inputValue > this.maximum;
  }
  get maximum() {
    var _a;
    return (_a = this.props.maximum) != null ? _a : 100;
  }
};
SliderInput.defaultProps = {
  initialInputValue: 25,
  theme: SliderTheme.Light,
  minimum: 0,
  handleValueChange: () => {
  }
};
__decorateClass([
  observable
], SliderInput.prototype, "rangeInputValue", 2);
__decorateClass([
  observable
], SliderInput.prototype, "textInputValue", 2);
__decorateClass([
  computed
], SliderInput.prototype, "maximum", 1);
SliderInput = __decorateClass([
  observer
], SliderInput);
export default SliderInput;
